const carouselItems = [
  {
    title: '红桃视频 · 年度热门剧场',
    desc: '精选年度最受好评影视剧集，从口碑热剧到独家综艺，红桃视频专区为你呈现最具话题性的视频内容。每日更新推荐片单，不错过任何一部好剧。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20warm%20red%20and%20gold%20abstract%20film%20collection%2C%20elegant%20movie%20poster%20collage%20style%2C%20dramatic%20cinematic%20lighting%2C%20premium%20entertainment%20branding%2C%20rich%20textures%2C%20professional%20film%20aesthetic%2C%20no%20text%2C%20no%20faces&width=800&height=450&seq=carousel-1&orientation=landscape',
    tag: '热播推荐',
  },
  {
    title: '西瓜视频免费 · 大片放映厅',
    desc: '西瓜视频免费专区集结海量精品大片，涵盖动作、喜剧、悬疑、爱情等多种类型。高清画质流畅播放，免注册即点即看，享受纯粹的观影乐趣。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Vibrant%20green%20and%20gold%20abstract%20cinema%20theme%2C%20summer%20fresh%20movie%20atmosphere%2C%20modern%20film%20strip%20elements%2C%20dynamic%20entertainment%20design%2C%20bright%20playful%20composition%2C%20professional%20streaming%20aesthetic%2C%20no%20text%2C%20no%20faces&width=800&height=450&seq=carousel-2&orientation=landscape',
    tag: '免费专区',
  },
  {
    title: '小蓝视频 · 动漫番剧速递',
    desc: '小蓝视频频道专注动漫内容，最新番剧同步上线，热门日漫韩漫一网打尽。高清流畅不缓冲，为二次元爱好者提供最佳的追番体验平台。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cool%20blue%20and%20silver%20abstract%20anime%20style%20background%2C%20modern%20animation%20themed%20design%2C%20digital%20entertainment%20elements%2C%20clean%20geometric%20composition%2C%20smooth%20futuristic%20gradients%2C%20professional%20streaming%20aesthetic%2C%20no%20text%2C%20no%20faces&width=800&height=450&seq=carousel-3&orientation=landscape',
    tag: '动漫专场',
  },
  {
    title: '茄子视频 · 欧美精选佳作',
    desc: '茄子视频为您精选高分欧美影视作品，从奥斯卡获奖影片到独立电影佳作，从HBO经典剧集到Netflix热门原创。高清原声配字幕，原汁原味观赏体验。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20purple%20and%20gold%20cinematic%20abstract%20background%2C%20Hollywood%20glamour%20theme%2C%20film%20reel%20and%20spotlight%20elements%2C%20dramatic%20premium%20movie%20atmosphere%2C%20sophisticated%20design%2C%20no%20text%2C%20no%20faces&width=800&height=450&seq=carousel-4&orientation=landscape',
    tag: '欧美精选',
  },
  {
    title: '久久视频 · 经典怀旧影院',
    desc: '久久视频致力于经典影视修复与重映，让老电影焕发新生。从黑白默片时代到港片黄金年代，珍贵影像资料高清修复，唤醒一代人的银幕记忆。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Vintage%20sepia%20and%20gold%20classic%20cinema%20theme%2C%20old%20Hollywood%20nostalgic%20atmosphere%2C%20film%20noir%20elements%2C%20antique%20movie%20camera%20aesthetic%2C%20warm%20nostalgic%20lighting%2C%20elegant%20retro%20design%2C%20no%20text%2C%20no%20faces&width=800&height=450&seq=carousel-5&orientation=landscape',
    tag: '经典修复',
  },
  {
    title: '芒果视频 · 独家综艺盛宴',
    desc: '芒果视频独家打造原创综艺内容矩阵，从音乐竞演到旅行真人秀，从脱口秀到美食节目。每周多档节目同步上线，热点话题不断，精彩内容享不停。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Bright%20orange%20and%20yellow%20abstract%20variety%20show%20theme%2C%20vibrant%20stage%20lighting%20design%2C%20energetic%20entertainment%20atmosphere%2C%20dynamic%20colorful%20composition%2C%20modern%20TV%20production%20aesthetic%2C%20no%20text%2C%20no%20faces&width=800&height=450&seq=carousel-6&orientation=landscape',
    tag: '独家综艺',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
            热门专题
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900">
            焦点专题 · 一睹为快
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            六大热门频道专题合集，发现属于你的观影偏好
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 md:gap-6">
          {carouselItems.map((item) => (
            <a
              key={item.title}
              href="#cards"
              className="group relative rounded-2xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer flex flex-col sm:flex-row"
            >
              <div className="relative w-full sm:w-48 md:w-56 h-48 sm:h-auto flex-shrink-0 overflow-hidden">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-primary-500/90 text-background-50 text-xs font-medium">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="flex-1 p-5 flex flex-col justify-center">
                <h3 className="text-base md:text-lg font-bold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}